import axios from 'axios';
import { loadingActions } from '../redux/actions';
import { Store } from '../redux/stores';

export const createGrid = async (tableId, grid) => {
    Store.dispatch(loadingActions.loadingStart('grid.createGrid'));
    try {
        let resp = await axios.post(`${process.env.REACT_APP_HOST}/table/${tableId}/grid`, {
            "name": grid.name,
            "render_props": grid.render_Props,
            "gmmode_props": grid.gmmode_props,
            "gridType": grid.gridType,
            "gridScale": grid.gridScale,
            "gridUnit": grid.gridUnit,
            "gridMeasureType": grid.gridMeasureType,
        });
        Store.dispatch(loadingActions.loadingEnd('grid.createGrid'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('grid.createGrid'));
        return e.response.data;
    }
};

export const listGrids = async (tableId) => {
    Store.dispatch(loadingActions.loadingStart('grid.listGrids'));
    const defaultReposne = {status:'error', payload: {grids:[]}};
    try {
        let resp = await axios.get(`${process.env.REACT_APP_HOST}/table/${tableId}/grid`);
        Store.dispatch(loadingActions.loadingEnd('grid.listGrids'));
        return resp && resp.data ? resp.data : defaultReposne;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('grid.listGrids'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultReposne;
    }
};

export const updateGrid = async (tableId, grid) => {
    Store.dispatch(loadingActions.loadingStart('grid.updateGrid'));
    try {
        let resp = await axios.put(`${process.env.REACT_APP_HOST}/table/${tableId}/grid/${grid.id}`, {
            "name": grid.name || null,
            "render": grid.render ? (typeof grid.render === 'string' ? JSON.parse(grid.render) : grid.render) : null,
            "layers": grid.layers ? (typeof grid.layers === 'string' ? JSON.parse(grid.layers) : grid.layers) : null,
            "gridType" : grid.gridType ? grid.gridType : null,
            "gridScale" : grid.gridScale ? grid.gridScale : null,
            "gridUnit" : grid.gridUnit ? grid.gridUnit : null,
            "gridMeasureType" : grid.gridMeasureType ? grid.gridMeasureType : null,
        });
        Store.dispatch(loadingActions.loadingEnd('grid.updateGrid'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('grid.updateGrid'));
        return e.response.data;
    }
};

export const deleteGrid = async (tableId, grid) => {
    Store.dispatch(loadingActions.loadingStart('grid.deleteGrid'));
    try {
        let resp = await axios.delete(`${process.env.REACT_APP_HOST}/table/${tableId}/grid/${grid.id}`);
        Store.dispatch(loadingActions.loadingEnd('grid.deleteGrid'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('grid.deleteGrid'));
        return e.response.data;
    }
};

export const getGrid = async (tableId, gridId) => {
    Store.dispatch(loadingActions.loadingStart('grid.getGrid'));
    try {
        let resp = await axios.get(`${process.env.REACT_APP_HOST}/table/${tableId}/grid/${gridId}`);
        Store.dispatch(loadingActions.loadingEnd('grid.getGrid'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('grid.getGrid'));
        return e.response.data;
    }
};

export const setGridActive = async (tableId, gridId) => {
    Store.dispatch(loadingActions.loadingStart('grid.setGridActive'));
    try {
        let resp = await axios.post(`${process.env.REACT_APP_HOST}/table/${tableId}/grid/${gridId}/setactive`);
        Store.dispatch(loadingActions.loadingEnd('grid.setGridActive'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('grid.setGridActive'));
        return e.response.data;
    }
};

export const addToGrid = async (tableId, gridId, items, layer, layers) => {
    Store.dispatch(loadingActions.loadingStart('grid.addToGrid'));
    try {
        let resp = await axios.post(`${process.env.REACT_APP_HOST}/table/${tableId}/grid/${gridId}/content`, {
            "renderItems": items || null,
            "selectedLayer": layer || null,
            "layers": layers ? (typeof layers === 'string' ? JSON.parse(layers) : layers) : null
        });
        Store.dispatch(loadingActions.loadingEnd('grid.addToGrid'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('grid.addToGrid'));
        return e.response.data;
    }
};

export const changeGrid = async (tableId, gridId, items, layer, layers) => {
    Store.dispatch(loadingActions.loadingStart('grid.changeGrid'));
    try {
        let resp = await axios.put(`${process.env.REACT_APP_HOST}/table/${tableId}/grid/${gridId}/content`, {
            "renderItems": items || null,
            "selectedLayer": layer || null,
            "layers": layers ? (typeof layers === 'string' ? JSON.parse(layers) : layers) : null
        });
        Store.dispatch(loadingActions.loadingEnd('grid.changeGrid'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('grid.changeGrid'));
        return e.response.data;
    }
};

export const changeLayer = async (tableId, gridId, items, layer) => {
    Store.dispatch(loadingActions.loadingStart('grid.changeLayer'));
    try {
        let resp = await axios.put(`${process.env.REACT_APP_HOST}/table/${tableId}/grid/${gridId}/changelayer`, {
            "renderItems": items || null,
            "selectedLayer": layer || null
        });
        Store.dispatch(loadingActions.loadingEnd('grid.changeLayer'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('grid.changeLayer'));
        return e.response.data;
    }
};

export const changeOrder = async (tableId, gridId, items, layer, distance) => {
    Store.dispatch(loadingActions.loadingStart('grid.changeOrder'));
    try {
        let resp = await axios.put(`${process.env.REACT_APP_HOST}/table/${tableId}/grid/${gridId}/reorder`, {
            "renderItems": items || null,
            "selectedLayer": layer || null,
            "distance": distance || null,
        });
        Store.dispatch(loadingActions.loadingEnd('grid.changeOrder'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('grid.changeOrder'));
        return e.response.data;
    }
};

export const deleteFromGrid = async (tableId, gridId, items, layer) => {
    Store.dispatch(loadingActions.loadingStart('grid.deleteFromGrid'));
    try {
        let resp = await axios.delete(`${process.env.REACT_APP_HOST}/table/${tableId}/grid/${gridId}/content`, {
            data: {
                "renderItems": items || null,
                "selectedLayer": layer || null
            }
        });
        Store.dispatch(loadingActions.loadingEnd('grid.deleteFromGrid'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('grid.deleteFromGrid'));
        return e.response.data;
    }
};